<template>
	<b-modal ref="modal" title="Edit item" :busy="loading>0">
		<b-form @submit.stop.prevent="save(); return false" id="userEditForm">
			<b-form-group label="User name">
				<b-form-input v-model="curUser.username" placeholder="User name" required></b-form-input>
			</b-form-group>
			<b-form-group label="Email">
				<b-form-input type="email" v-model="curUser.email" placeholder="Email"></b-form-input>
			</b-form-group>
			<b-form-group label="Password">
				<b-form-input type="password" v-model="curUser.password" placeholder="Password" :required="!id"></b-form-input>
			</b-form-group>
			<b-form-group label="Restreaming Service">
				<b-form-select v-model="curUser.restreaming_service_id" :options="[ { id: null, name: 'None' }, ...services]" value-field="id" text-field="name"></b-form-select>
			</b-form-group>
			<hr />
			<b-form-group label="Stripe customer ID">
				<b-form-input v-model="curUser.stripe_customer_id" placeholder="cus_..." monospace></b-form-input>
			</b-form-group>
			<b-form-group label="Stripe subscription ID">
				<b-form-input v-model="curUser.stripe_subscription_id" placeholder="sub_..." monospace></b-form-input>
			</b-form-group>
			<b-form-group label="Stripe subscription status">
				<b-form-input v-model="curUser.subscription_status" placeholder="" monospace></b-form-input>
			</b-form-group>
		</b-form>
		<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
		<template #modal-footer="{cancel}">
			<b-spinner v-show="loading>0" small label="Loading"></b-spinner>
			<b-button size="sm" variant="success" type="submit" form="userEditForm">
				Save
			</b-button>
			<b-button size="sm" @click="cancel()">
				Cancel
			</b-button>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: 'UserEditModal',
	data() { return {
		services: [],
		id: null,
		curUser: {settings: {}},
		loading: 0,
		error: null
	}},
	methods: {
		load(promise) {
			this.loading++;
			promise.catch(err => {
				this.error = err&&err.error||err.toString();
			}).finally(() => {
				this.loading--;
			});
			return promise;
		},
		loadServices() {
			this.load(this.$api.get('restreaming/services')).then(services => this.services = services);
		},
		show(id) {
			this.loadServices();
			this.error = null;
			if(id) {
				this.$set(this, 'id', id);
				this.load(this.$api.get(`user/${id}`)).then(user => {
					user.password = '';
					this.curUser = user
				});
			} else {
				this.$set(this, 'id', null);
				this.curUser = {settings:{}};
			}

			this.$refs.modal.show();
		},
		save() {
			let data = {
				username: this.curUser.username,
				password: this.curUser.password,
				email: this.curUser.email,
				restreaming_service_id: this.curUser.restreaming_service_id,
				stripe_customer_id: this.curUser.stripe_customer_id,
				stripe_subscription_id: this.curUser.stripe_subscription_id,
				subscription_status: this.curUser.subscription_status,
			};
			if(this.id) {
				this.load(this.$api.post(`user/${this.id}`, data)).then(() => {
					this.$refs.modal.hide();
					this.$bvToast.toast('Successfully saved user', { title: 'Success', variant: 'success', solid: true });
					this.$emit('saved');
				});
			} else {
				this.load(this.$api.post(`user`, data).then(() => {
					this.$refs.modal.hide();
					this.$bvToast.toast('Successfully created user', { title: 'Success', variant: 'success', solid: true });
					this.$emit('saved');
				}))
			}
		},
	}
};
</script>
